<script lang="ts">
  // Die sechs Punkte heißen „verschiebbar" -- überall dieselben: am
  // Spaltenkopf einer Tabelle (DataTableHead) und an jeder Karte im
  // Sortiermodus (lib/anordnung.svelte.ts). Wo eine Karte keinen eigenen
  // Kopf hat, malt app.css dieselben Punkte (`[data-anordnung-punkte]`).
  interface Props {
    /** Höhe in px; die Breite folgt dem Seitenverhältnis 10:16 */
    hoehe?: number;
    class?: string;
  }
  let { hoehe = 11, class: klasse = "" }: Props = $props();
</script>

<svg
  viewBox="0 0 10 16"
  width={Math.round((hoehe * 10) / 16)}
  height={hoehe}
  fill="currentColor"
  aria-hidden="true"
  class="shrink-0 {klasse}"
>
  <circle cx="2.5" cy="3" r="1.2" /><circle cx="7.5" cy="3" r="1.2" />
  <circle cx="2.5" cy="8" r="1.2" /><circle cx="7.5" cy="8" r="1.2" />
  <circle cx="2.5" cy="13" r="1.2" /><circle cx="7.5" cy="13" r="1.2" />
</svg>
